import { SignOutButton, useAuth } from '@clerk/clerk-react';
import { Outlet } from 'react-router-dom';
import { Button } from '@/components/ui';
import { Icon } from '@/lib/icons';
import { setApiTokenGetter } from '@/data/api';
import { useMe } from './useMe';

/* Gate below RequireAuth: a signed-in Clerk user is not necessarily a clientIQ
   member. tritonIQ client logins share the Clerk instance, and the API answers
   them 403 not_invited — this turns that into a readable page.

   The token getter is wired here, during render, rather than in an effect: child
   effects run before parent effects, so wiring it in AppShell's useEffect let the
   first queries go out unauthenticated. */
export function RequireMember() {
  const { getToken } = useAuth();
  setApiTokenGetter(() => getToken());
  const { me, isLoading, notInvited, error } = useMe();

  if (isLoading) return null;
  if (notInvited) {
    return (
      <div className="auth-shell">
        <div className="auth-shell__brand">
          <img src="/triton-logo.png" alt="Triton" className="auth-shell__logo" />
        </div>
        <div className="dash-empty">
          <span className="dash-empty__icon"><Icon name="lock" size={28} /></span>
          <h2>No clientIQ access</h2>
          <p>This account has not been invited to clientIQ. If you work at Triton, ask an admin to invite the email you signed in with.</p>
          <SignOutButton><Button variant="outline">Sign out</Button></SignOutButton>
        </div>
      </div>
    );
  }
  if (!me) {
    return (
      <div className="dash-empty">
        <h2>Could not load clientIQ</h2>
        <p>{error instanceof Error ? error.message : 'Unknown error'}</p>
      </div>
    );
  }
  return <Outlet />;
}
